import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLayout.vue?vue&type=style&index=0&id=51f2bb0a&lang=scss"

const __exports__ = script;

export default __exports__